import { STORAGE_KEYS as s } from "./storage-manager.js";
export function getAlias(e) {
  var t = null == e ? void 0 : e.ft(s.gt._E);
  var n;
  return t && (n = {
    label: t.l,
    name: t.a
  }), n;
}